const images = [
  {
    url:"https://images.vexels.com/media/users/3/193703/raw/714f169d00d7ce76764c2186dc14eb62-read-a-book-slider-template.jpg"
  },
  {
    url:"https://www.indesprocom.com/wp-content/uploads/2017/09/book-slider.jpg"
  },
  {
    url:"https://alethiabooks.com/wp-content/uploads/2020/05/Slider-Banner-webpage2.jpg"
  },
  {
    url:"https://s26162.pcdn.co/wp-content/uploads/2018/03/Screen-Shot-2018-03-04-at-9.58.08-PM.png"
  },
  {
    url: "https://www.az-bookstore.com/wp-content/uploads/2020/01/Book_Slider2.jpg"
  },
  {
    url:"https://th.bing.com/th/id/OIP.T-17sHhacEskeePhGsgvwQHaD-?pid=ImgDet&w=1050&h=563&rs=1"
  },
];

export default images;
